var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("PageWrapper", {
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _vm.showPage
              ? _c(
                  "div",
                  { staticClass: "custom-table" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "el-icon-plus custom-btn",
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.handleAdd },
                      },
                      [_vm._v("新增用户")]
                    ),
                    _c(
                      "el-table",
                      {
                        staticClass: "customer-table",
                        attrs: {
                          border: "",
                          fit: "",
                          "highlight-current-row": "",
                          data: _vm.list,
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "序号", prop: "id" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "姓名", prop: "rname" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "账号", prop: "username" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "创建时间", prop: "settime" },
                        }),
                        _c("el-table-column", {
                          attrs: { label: "操作" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "el-icon-edit-outline",
                                        attrs: {
                                          type: "primary",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleEdit(scope)
                                          },
                                        },
                                      },
                                      [_vm._v(" 编辑 ")]
                                    ),
                                    _c(
                                      "el-popconfirm",
                                      {
                                        attrs: {
                                          iconColor: "red",
                                          title: "确认删除此条数据吗？",
                                        },
                                        on: {
                                          confirm: function ($event) {
                                            return _vm.handleDelete(
                                              scope.row,
                                              scope.$index
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            staticClass: "el-icon-delete",
                                            attrs: {
                                              slot: "reference",
                                              type: "danger",
                                              size: "small",
                                            },
                                            slot: "reference",
                                          },
                                          [_vm._v("删除")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1521507254
                          ),
                        }),
                      ],
                      1
                    ),
                    _c("el-pagination", {
                      staticStyle: {
                        "margin-top": "14px",
                        "margin-bottom": "14px",
                      },
                      attrs: {
                        "current-page": _vm.selectPage.pageNum,
                        "page-sizes": [20, 50, 100, 200],
                        "page-size": _vm.selectPage.pageSize,
                        background: "",
                        layout: "total, sizes, prev, pager, next, jumper",
                        total: _vm.allNum,
                      },
                      on: {
                        "size-change": _vm.pageSizeChange,
                        "current-change": _vm.pageCurrentChange,
                      },
                    }),
                  ],
                  1
                )
              : _c("el-empty", {
                  staticClass: "customer-category_empty",
                  attrs: { description: "暂无权限查看数据" },
                }),
            _c("Edit", {
              attrs: {
                dialog: _vm.dialog,
                "form-data": _vm.editFormData,
                type: _vm.type,
              },
              on: { submit: _vm.handleSubmit, close: _vm.handleClose },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }